import { deleteConfig } from './delete';
import { createConfig } from './update';

export default {
  deleteConfig,
  createConfig,
};
